import styled from '@emotion/styled';

import { CheckboxElementProps } from './types';

export const CheckboxElement = styled.div<CheckboxElementProps>`
  font-family: ${({ theme }) => theme.checkbox.general.font_family};
  font-size: ${({ theme }) => theme.checkbox.general.font_size};
  gap: ${({ theme }) => theme.checkbox.general.gap};
  color: ${({ theme }) => theme.checkbox.color.normal};

  &:hover {
    color: ${({ theme }) => theme.checkbox.color.hover};
  }

  &:hover svg {
    color: ${({ theme }) => theme.checkbox.color.active};
  }

  &[aria-checked='true'] svg {
    color: ${({ theme }) => theme.checkbox.color.active};
  }

  &[data-disabled='true'] {
    color: ${({ theme }) => theme.checkbox.color.disabled};
    pointer-events: none;
    opacity: 0.8;

    &:hover {
      color: ${({ theme }) => theme.checkbox.color.disabled};
    }
  }
`;
